import { Button, Column, Form, Grid, Row, TextInput, Tile } from "carbon-components-react";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { createIndustry } from "../../redux/actions/industryAction";

function IndustryFormPage({ isLoading }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const [formContent, setFormContent] = useState({
    industryName: undefined,
  })

  const submitForm = (e) => {
    e.preventDefault()

    dispatch(createIndustry(formContent, (_data) => {
      history.push("/industries")
    }))
  }

  return (
    <UIShell breadcrumbs={[
      { name: 'Home', link: "/" },
      { name: 'Industries', link: "/industries" },
      { name: 'Create' }
    ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Form onSubmit={submitForm}>
                <TextInput
                    autoFocus={true}
                    labelText="Industry Name"
                    value={formContent.industryName}
                    onChange={(v) => setFormContent((_state) => ({
                        ..._state,
                        industryName: v.target.value
                    }))}
                />
                <Padding top="1rem">
                    <Button 
                      disabled={isLoading} 
                      type="submit" 
                      kind="primary"
                    >
                      Save
                    </Button>
                    <Button 
                      onClick={() => history.push("/industries")} 
                      kind="secondary"
                    >
                      Cancel
                    </Button>
                </Padding>
              </Form>
            </Tile>
          </Column>
        </Row>
      </Grid>
    </UIShell>
  )
}

const mapStateToProps = state => {
  return {
    isLoading: state.uxReducer.isLoading
  }
}

export default connect(mapStateToProps)(IndustryFormPage)